export const getActivationJourneySteps = ({
  planLabel,
  trialDaysCopy,
  hasUsedTrial = false,
}) => [
  {
    key: "plan",
    eyebrow: "Paso 1",
    title: planLabel ? "Confirma tu plan" : "Elige tu rol",
    description: planLabel
      ? `Tu cuenta ya opera con ${planLabel}.`
      : "La cuenta define el plan y los límites disponibles.",
  },
  {
    key: "billing",
    eyebrow: "Paso 2",
    title: "Activa en Stripe",
    description: hasUsedTrial
      ? "Retoma o reactiva tu suscripción correspondiente."
        : "Comieza tus 14 días de prueba y activa tu plan de pago",
  },
  {
    key: "operate",
    eyebrow: "Paso 3",
    title: "Regresa al dashboard",
    description:
      "Las herramientas premium se desbloquean en cuanto la activación queda lista.",
  },
];